<script setup>
import { mdiCheck } from '@mdi/js'

const props = defineProps(['baseForm'])
const emit = defineEmits(['click'])
</script>

<template>
<v-btn
	v-if="baseForm"
	v-bind="$attrs"
	:prepend-icon="mdiCheck"
	variant="outlined"
	type="submit"
	:form="baseForm.formId"
>
	<slot>Save</slot>
</v-btn>
<v-btn 
	v-else
	v-bind="$attrs"
	:prepend-icon="mdiCheck"
	variant="outlined"
	:disabled="$attrs.disabled"
	@click.stop="emit('click')"
>
	<slot>Save</slot>
</v-btn>
</template>
<style lang="scss" scoped>

</style>